import { IconButton, Typography, Box, AppBar, Toolbar, Container } from '@mui/material';

import { useEffect, useState } from 'react';


// import { ReactComponent as SputnikIcon } from 'assets/images/orbotnik_54X54.svg';
import '@rhino/shared/assets/styles/Header.scss';
import Sidebar from '@rhino/shared/components/common/sidebar/Sidebar';
import { selectCurrentEvent, selectStatus } from '@rhino/shared/services/redux/shuteSlice'; 
import { setLoginOpen , selectAuthenticated } from '@rhino/shared/services/redux/authSlice';
import { ButtonWithAuth, IconButtonWithAuth, SettingType } from '@rhino/shared/services/auth/auth';
// import { fnPushBostonEvent } from '@rhino/shared/services/sputnikapi';
// import ErrorContext, { ErrorContextType } from '@rhino/shared/contexts/ErrorContext';
import OrbotnikIcon from '@rhino/shared/components/common/Icons/Icons';
import { useAppDispatch, useAppSelector } from '@rhino/shared/services/redux/hooks';
import { SidebarContent } from './SidebarMenu';
import { itemPendingInSaveQueue } from '@rhino/shared/services/redux/prefsSlice';


function Header() {
  const dispatch = useAppDispatch();
  const [socketActive, setSocketActive] = useState(false);

  const status = useAppSelector(selectStatus);
  const latestMessage = useAppSelector(selectCurrentEvent);
  
  // // Function that runs when a message is sent or received over the WebSocket
  // useEffect(() => {
  //   if (!(latestMessage?.event === "shute.ping")) {
  //     showSocketActivity();
  //   };
  // }, [latestMessage,status]);

  // const showSocketActivity = () => {
  //   setSocketActive(true);
  //   setTimeout(() => {
  //     setSocketActive(false);
  //   }, 2000);
  // };


  
  
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  const handleSidebarOpen = () => {
    setSidebarOpen(true);
  };
  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };
  const handleLoginClick = () => {
    dispatch(setLoginOpen(true)); // dispatch the action to open the dialog
  };

  const isAuthenticated = useAppSelector(selectAuthenticated); 

  useEffect(() => {
    // This effect runs whenever isAuthenticated changes. If the user is not authenticated 
    // (isAuthenticated is false), it dispatches an action to open the login dialog.
    // This ensures that unauthenticated users are prompted to log in.
    if (!isAuthenticated) {
        dispatch(setLoginOpen(true));
      }
  }, [dispatch, isAuthenticated]);
  const settings:SettingType[] = [
    { key:'Nebulon', caption: 'Nebulon!', tooltip: 'Show Nebulon Spread', route: '/nebulon', iconname: 'CommentBank', sxstyles: {color:'inherit'}, authmode:  'show' },
    { key:'Camera', caption: 'Live Camera', tooltip: 'Live Cameras', route: '/cameras', iconname: 'CameraOutdoor', authmode: 'show', sxstyles: {color:'inherit'} },
    { key:'Media', caption: 'Media Viewer', tooltip: 'Media Viewer page', route: '/mediaarchive', iconname: 'YouTube', authmode: 'show', sxstyles: {color:'inherit'} },
    { key:'Home', caption: 'Home', tooltip: 'Return to Home Page', route: '/', iconname: 'Home', authmode: 'show', sxstyles: {color:'inherit'}},
  ];

  const showPendingSave = useAppSelector(state => itemPendingInSaveQueue(state, 1, undefined, 'userattributes.state'));

  return (
    <div id="div_ResponsiveAppBar">
      <AppBar position="static">
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Box sx={{ flexGrow: 1, display: "flex", alignItems: 'center' }}>
              <IconButtonWithAuth key="Menu" setting={{ key: 'Menu', sxstyles: {color:'inherit'}, tooltip: 'Menu', iconname: 'Menu', authmode: 'enable', onClick:handleSidebarOpen }}  />
              <Box sx={{ display: 'flex', mr: 1, width: '24px', height: '24px', alignItems: "flex-start"  }}>
                <img src="/assets/images/orbotnik_54X54.svg" alt="Sputnik" style={{ width: '100%', height: '100%' }} />
              </Box>
              <Typography
                variant="h6"
                noWrap
                component="a"
                href="/"
                sx={{
                  mr: 2,
                  display: { xs: 'none', md: 'flex' },
                  fontFamily: 'monospace',
                  fontWeight: 700,
                  letterSpacing: '.3rem',
                  color: 'inherit',
                  textDecoration: 'none',
                  alignItems: 'center',
                }}
              >
                ORBOTNIK
              </Typography>
            </Box>
            {socketActive && (
              <IconButton>
                <OrbotnikIcon iconName="Announcement" color="inherit" />
              </IconButton>
            )}
            {showPendingSave && (
              <IconButton>
                <OrbotnikIcon iconName="Save" color="inherit" />
              </IconButton>
            )}            
            {/* // Show menu icons on small */}
            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' },justifyContent: 'flex-end' }}>
              {settings.map((setting) => (
                <IconButtonWithAuth key={setting.key} setting={setting} />
              ))}
              <IconButtonWithAuth key="Login" setting={{ key: 'Login', tooltip: 'Login', iconname: 'Login', authmode: 'hide',sxstyles: {color:'inherit'},onClick:handleLoginClick}} />
            </Box>
            {/* // Show text button on large */}
            <Box sx={{ flexGrow: 0, display: { xs: 'none', md: 'flex' } }}>
              {settings.map((setting) => (
                <ButtonWithAuth key={setting.key} setting={setting} />
              ))}  
              <ButtonWithAuth key="Login" setting={{ caption: 'Login', tooltip: 'Login', key: 'Login', authmode: 'hide', onClick:handleLoginClick}}  />
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Sidebar anchor="left" isOpen={sidebarOpen} onClose={handleSidebarClose}>
        <SidebarContent hideSideBar={handleSidebarClose} />
      </Sidebar>
    </div>
  );
}



export default Header;